import { useState } from 'react';
import { useAccountInvoiceData } from '@/domains/invoices/services/account-invoices';
import { Invoices } from '@/domains/invoices/components/Invoices';
import { subMonths } from 'date-fns';
import { usePermissions } from '@/shared/hooks/use-permissions';
import { OrgType } from '@/shared/types/userRoleTypes';
import { Feature, Permission } from '@/shared/types/permissionsTypes';

export const InvoicesTab = () => {
  const { hasPermission } = usePermissions();
  const defaultBillingPeriod = subMonths(new Date(), 1).toISOString().split('T')[0];

  const [selectedBillingPeriod, setSelectedBillingPeriod] = useState<string>(defaultBillingPeriod);

  // Fetch account usage data
  const { data: invoiceData, isLoading, error, refetch } = useAccountInvoiceData(selectedBillingPeriod);

  return (
    <Invoices
      selectedRegionCode={undefined}
      invoices={invoiceData ? [invoiceData] : []}
      isLoading={isLoading}
      error={error}
      hasPermission={hasPermission(OrgType.TENANT, Feature.INVOICES, Permission.MANAGE)}
      refetch={refetch}
      onBillingPeriodChange={(billingPeriod) => setSelectedBillingPeriod(billingPeriod)}
    />
  );
}
